// eslint-disable-next-line @nx/enforce-module-boundaries
import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';
import { ddApps, ddApplicationIds, ddClientTokens, initialiseDataDogRUM } from '@clearscore-group/lib.tools.datadog';

export default () => {
    if (canUseDom()) {
        const application = `${window.__cs__.env.SITE}Website`;
        initialiseDataDogRUM({
            app: ddApps[application],
            applicationId: ddApplicationIds[application],
            clientToken: ddClientTokens[application],
            sessionSampleRate: 1,
        });
    }
};
